/**
 * Keycloak refuses a direct-grant (username/password) login with this opaque
 * description whenever the credentials are ACCEPTED but the account still
 * carries a pending required action — in our realms that is "Update Password",
 * which the realm's password-expiry policy adds on its own. user-service
 * forwards Keycloak's description verbatim, so the sign-in surface is where it
 * has to become something the user can act on: they cannot get in until the
 * password is reset, and the reset endpoint clears the required action.
 */
const REQUIRED_ACTION_ERROR = 'account is not fully set up';

/**
 * Maps a raw sign-in failure message onto user-facing copy. Anything we don't
 * recognize passes through untouched, so a new server-side message still
 * reaches the user instead of being swallowed by a generic fallback.
 */
export function resolveSignInError(
  message: string | null | undefined,
  t: (key: string) => string,
): string | null {
  if (!message) return null;
  if (message.toLowerCase().includes(REQUIRED_ACTION_ERROR)) {
    return t('signIn.errors.passwordUpdateRequired');
  }
  return message;
}
